import React from "react";
import {Select} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {ReactComponent as AmericanFlagIcon} from "../../icons/flags/american.svg";
import {ReactComponent as RussianFlagIcon} from "../../icons/flags/russia.svg";

const items = [
  {code: "USD", label: "Доллар США", icon: <AmericanFlagIcon/>},
  {code: "RUB", label: "Российский рубль", icon: <RussianFlagIcon/>},
];

export default function CurrencyDropdown({value, onChange}) {
  return (
    <Select
      value={value}
      onChange={onChange}
      variant="borderless"
      className="currency-dropdown-select"
      popupClassName="currency-dropdown-popup"
      suffixIcon={<DownOutlined className="text-[#999] text-xs"/>}
      options={items.map((item) => ({
        value: item.code,
        label: (
          <div className="flex items-center gap-3">
            <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0">
              {item.icon}
            </span>
            <span className="subtitle-2 truncate">
              <span className="text-[#01051F] font-medium">{item.code}</span>
              {" - "}
              <span className="text-[#5C607C]">{item.label}</span>
            </span>
          </div>
        ),
      }))}
    />
  );
}
